<template>
  <div class="role" v-if="model">
    <div class="body">
      <div class="main">
        <span class="title">{{ model.data.title }}</span>
        @
        <span class="employer">{{ model.data.employer.name }}</span>&nbsp;
        <span class="location">({{ model.data.employer.location }})</span>
      </div>
      <div class="aux">
        <div class="dates">{{ model.dateRange() }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    name  : "Role",
    props : {
        model : {
            type : Object
        }
    }
};

</script>

<style scoped>

.role {
}

.role .body {
    display:flex;
    flex-wrap:nowrap;
    align-items:flex-end;
    justify-content:space-between;
}

.role .main {
    font-size:14px;
    text-align:left;
}

.role .aux {
    font-size:14px;
    text-align:right;
}

.role .title,
.role .employer {
    font-weight:bold;
}

.role .dates {
    text-transform:lowercase;
    font-variant:small-caps;
    margin-left:30px;
    white-space:nowrap;
}

</style>
